"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanSubscriptionType = exports.PlanLanguageType = void 0;
var PlanLanguageType;
(function (PlanLanguageType) {
    PlanLanguageType["Single"] = "single";
    PlanLanguageType["Multi"] = "multi";
})(PlanLanguageType = exports.PlanLanguageType || (exports.PlanLanguageType = {}));
var PlanSubscriptionType;
(function (PlanSubscriptionType) {
    PlanSubscriptionType["Paid"] = "paid";
    PlanSubscriptionType["Backer"] = "backer";
})(PlanSubscriptionType = exports.PlanSubscriptionType || (exports.PlanSubscriptionType = {}));
//# sourceMappingURL=plan.js.map